<template>
    <div class="condition-bar text-left">
        <div v-for="i in 5" :key="i" :style="{display: 'inline-block', borderRadius: '2px', width: '15%', height: '8px', marginRight: '2px', 
            backgroundColor: i <= value ? colorMap[value]:grayColor}"></div>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data() {
        return {
            grayColor: "rgba(0,0,0,0.15)",
            colorMap: {
                1: '#bd4141',
                2: '#deb6b6',
                3: '#c7b90d',
                4: 'yellowgreen',
                5: '#329a32'
            }
        }
    }
}
</script>

<style scoped>
.condition-bar {
    width: 100%;
}
</style>